import { render, staticRenderFns } from "./EmulatorDemo.vue?vue&type=template&id=096e4c6c&scoped=true"
import script from "./EmulatorDemo.vue?vue&type=script&lang=js"
export * from "./EmulatorDemo.vue?vue&type=script&lang=js"
import style0 from "./EmulatorDemo.vue?vue&type=style&index=0&id=096e4c6c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096e4c6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('096e4c6c')) {
      api.createRecord('096e4c6c', component.options)
    } else {
      api.reload('096e4c6c', component.options)
    }
    module.hot.accept("./EmulatorDemo.vue?vue&type=template&id=096e4c6c&scoped=true", function () {
      api.rerender('096e4c6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Emulator/EmulatorDemo.vue"
export default component.exports